import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import axios from 'axios';
import fetchConfig from '../../Constants/fetch';
import VideoTemplate from '../VideoTemplate/VideoTemplate';
import AccordionFAQ from '../AccordionFAQ/AccordionFAQ';

/* eslint-disable no-param-reassign */
/* eslint-disable prettier/prettier */
/* eslint-disable default-case */
/* eslint-disable react/jsx-curly-brace-presence */

const VideoSection = styled.section`
    display: flex;
    flex-direction: row;
    column-gap: 50px;
    margin-bottom: 25px;
`;

const PageTitles = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
const PageContent = styled.div`
    width: ${prop => (prop.isLogin ? '50vw' : '65vw')};
    // margin-top: 30px;
`;

const SectionTitle = styled.h5`
    font-weight: 500;
`;

const TutorialsAndFAQ = ({ isLogin }) => {
    const [videoList, setVideoList] = useState([]);
    const [FAQList, setFAQList] = useState([]);
    const { t } = useTranslation();
    const chunkArray = (array, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    };
    
    useEffect(() => {
        const getToturials = async () => {

            try {
                const tutorials = await axios.get(`${fetchConfig.prefix}/auth/tutorials?isLogin=${isLogin}`);
                setVideoList(tutorials.data.videos.sort((a,b)=> a.item_order - b.item_order));
                setFAQList(tutorials.data.faq.sort((a,b)=> a.item_order - b.item_order));
            } catch {
                console.log('Cant get toturials');
            }
        };

        getToturials();
    }, [isLogin]);
    const chunkedVideoList = chunkArray(videoList, 4);


    return (
        <>
            <PageContent isLogin={isLogin}>
                <PageTitles>
                    <SectionTitle>{t('login.help.help_videos.videos_title')}</SectionTitle>
                    {/* <a href="https://vimeo.com/pmzone">See more &gt;&gt;</a> */}
                </PageTitles>
                {chunkedVideoList.map((chunk, index) => (
                    <VideoSection key={`row_${index}`}>
                        {chunk.map((element, index2) => (
                            <VideoTemplate key={`video_${index2}`} videoLink={element.link} title={element.title} id={element.id} />
                        ))}
                    </VideoSection>
                ))}
                {isLogin && 
                    <>
                        <PageTitles>
                            <SectionTitle>{t('login.help.help_faqs.faqs_title')}</SectionTitle>
                            {/* <a href="https://vimeo.com">See more &gt;&gt;</a> */}
                        </PageTitles>
                        <AccordionFAQ faq={FAQList} />
                    </>
                }
            </PageContent>
        </>
    );
};

export default TutorialsAndFAQ;
